import { jsxs as ce, jsx as c } from "react/jsx-runtime";
import { createContext as ue, useContext as me, useState as f, useRef as j, useEffect as G } from "react";
import { DaymapOidc as R, DaymapOidcConfig as D } from "./daymapoidc.js";
import { useSchool as de } from "../school/index.js";
import { U as fe } from "../../CustomPopupNavigator-Bz9uYcKp.js";
import { useQueryClient as pe } from "@tanstack/react-query";
import { C as ge } from "../../index-D7cgykJH.js";
import { B as F } from "../../index-BZpqZYNM.js";
import { ThemeProvider as H, Stack as we, Alert as ye, Button as he } from "@mui/material";
import { daymapTheme as Ie } from "../../theme/index.js";
import { LoadingOverlay as W } from "../../components/loadingoverlay/index.js";
import { A as z } from "../../index-D9-bkW7l.js";
const K = Ie({ GenerateCss: !0 }), Q = ue({
  Get: ({ url: p, config: l }) => (console.log(`GET request to: ${p}`, l), {}),
  Post: ({ url: p, data: l, config: u }) => (console.log(`POST request to: ${p} with data:`, l, u), {}),
  SignOut: () => {
    console.log("Sign out");
  },
  Unimpersonate: () => {
    console.log("Unimpersonate");
  },
  User: null,
  ClientId: null,
  IsImpersonating: !1
});
function Re() {
  return me(Q);
}
let N = !1;
const De = ({ children: p, device: l, clientId: u, appScheme: h = "daymap-companion", appType: M = z.Companion }) => {
  const [C, m] = f(!1), { identityUrl: U, schoolCode: n, baseUrl: S, ClearSchool: L } = de(), [I, T] = f([]), V = pe(), [E, X] = f(null), g = j(!1), [Y, Z] = f(!1), [O, ee] = f(!1), [_, te] = f(() => sessionStorage.getItem("isImpersonating") === "true");
  G(() => {
    let e;
    return F.addListener("browserFinished", () => {
      e = setTimeout(() => {
        Z(!0);
      }, 2e3);
    }), () => {
      F.removeAllListeners(), e && clearTimeout(e);
    };
  }, []), G(() => {
    !g.current && n && re();
  }, [n]), G(() => {
    l == null && (l = { token: "" });
    const { tokenError: e, deviceType: t, token: a = null } = l;
    C && (e || t === 0 || a !== null) && (V.clear(), (async () => {
      const s = await J({ url: S + `/lms/api/settings/user?redirectUrl=${h}://${n}/auth&clientId=${u}&deviceToken=${l.token ?? ""}&deviceType=${l.deviceType}&appType=${M}`, config: null });
      X(s);
    })());
  }, [C, l]);
  const A = (e) => {
    te(e), sessionStorage.setItem("isImpersonating", String(e));
  }, k = "Daymap_Stored_Users";
  let w = sessionStorage;
  if (ge.isNativePlatform() && (w = localStorage), I.length == 0) {
    const e = w.getItem(k);
    if (e) {
      const t = JSON.parse(e);
      T([...t]);
    }
  }
  const r = j(null), re = async () => {
    var s;
    g.current = !0, await ((s = r.current) == null ? void 0 : s.SignOut()), m(!1);
    const e = window.location.pathname.split("/");
    if (!(e[e.length - 1] === "impersonation") && I.length != 0 && I.some((i) => i.key == n)) {
      const i = I.find((o) => o.key == n);
      if (i) {
        r.current = new R(new D(u, U, n, h), i.user, P, n), r.current.UserManager.events.addUserLoaded((o) => {
          x({ key: n, user: o });
        }), m(!0), g.current = !1;
        return;
      }
    }
    switch (r.current = new R(new D(u, U, n, h), void 0, void 0, void 0), r.current.UserManager.events.addUserLoaded((i) => {
      x({ key: n, user: i });
    }), console.log("switching", e), e[e.length - 1]) {
      case "auth":
        for (; N; )
          await new Promise((o) => setTimeout(o, 50));
        N = !0;
        const i = await r.current.UserManager.signinCallback();
        if (i && i.state) {
          window.location = i.state;
          break;
        }
        await r.current.GetAccessToken(!1), m(!0);
        break;
      case "authsilent":
        await r.current.UserManager.signinSilentCallback(), await r.current.GetAccessToken(!1), m(!0);
        break;
      case "impersonation":
        try {
          const o = new URLSearchParams(window.location.search);
          let b = o.get("id"), d = o.get("userHash") ?? "", ae = o.get("xsUser") ?? "", $ = Number(o.get("type") ?? 3), y;
          if (d != null && d != "") {
            const le = localStorage.getItem(d);
            y = JSON.parse(le ?? "{}"), localStorage.removeItem(d);
          } else
            y = JSON.parse(ae);
          const v = new R(new D("Daymap.API", U, n, h), y, () => {
          }, n);
          await v.GetAccessToken(!1);
          let ie = window.location.origin, B = await v.GetResponse({ url: `${ie}/lms/api/impersonation?type=${$}&id=${b}&clientId=${$ == 1 ? "Daymap.API" : "Connect.API"}`, data: null, config: { method: "POST" } });
          r.current.UserManager.storeUser(new fe({ ...B, id_token: y.id_token, profile: y.profile, expires_at: Math.floor(Date.now() / 1e3) + (B.expires_in ?? 0) })), m(!0), A(!0), window.location.href = $ == 1 ? "/portals/student" : "/portal";
          break;
        } catch (o) {
          console.error("Impersonation failed", o);
          const b = new URLSearchParams(window.location.search);
          let d = Number(b.get("type") ?? 3);
          window.location.href = d == 1 ? "/portals/student" : "/portal";
          break;
        }
      default:
        await r.current.GetAccessToken(!1), m(!0);
        break;
    }
    const a = await r.current.UserManager.getUser();
    a && (x({ key: n, user: a }), N = !1, g.current = !1);
  }, x = (e) => {
    T((t) => (t.find((s) => s.key === e.key) ? t = t.map(
      (s) => s.key === e.key ? { ...s, user: e.user } : s
    ) : t = [...t, e], w.setItem(k, JSON.stringify(t)), [...t]));
  }, q = (e) => {
    T((t) => {
      const a = t.find((s) => s.key === e);
      return a ? t.splice(t.indexOf(a), 1) : t = [...t], t.length > 0 ? w.setItem(k, JSON.stringify(t)) : w.removeItem(k), [...t];
    });
  }, J = async ({ url: e, config: t }) => {
    var s;
    return r.current ? (t = { ...t, ...{} }, (s = r.current) == null ? void 0 : s.GetResponse({ url: e, data: null, config: t })) : {};
  }, ne = async ({ url: e, data: t, config: a }) => {
    var o;
    return r.current ? (a = { ...{ method: "POST" }, ...a }, await ((o = r.current) == null ? void 0 : o.GetResponse({ url: e, data: t, config: a }))) : {};
  }, P = async () => {
    var e;
    _ && A(!1), q(n), await ((e = r.current) == null ? void 0 : e.SignOut());
  }, se = () => {
    A(!1), q(n), sessionStorage.removeItem("isImpersonating"), M === z.StudentPortal ? window.location = `${S}/daymap/default.aspx?reset=1` : window.location = `${S}/daymap/Impersonate.aspx?impID=0&ImpType=0`;
  }, oe = async () => {
    ee(!0), g.current = !1, await P(), r.current && (await r.current.UserManager.clearStaleState(), r.current.isLocked = !1), L(), window.location.href = window.location.href;
  };
  return C ? E ? /* @__PURE__ */ c(Q.Provider, { value: { Get: J, Post: ne, SignOut: P, Unimpersonate: se, User: E, ClientId: u, IsImpersonating: _ }, children: p }) : /* @__PURE__ */ c(H, { theme: K, children: /* @__PURE__ */ c(W, { open: !0 }) }) : /* @__PURE__ */ ce(H, { theme: K, children: [
    O && /* @__PURE__ */ c(W, { open: !0, text: "Returning to login" }),
    !O && Y && n && /* @__PURE__ */ c(we, { gap: 2, p: 2, display: "flex", justifyContent: "center", alignItems: "center", height: "100%", children: /* @__PURE__ */ c(ye, { severity: "error", action: /* @__PURE__ */ c(he, { variant: "contained", color: "error", size: "small", onClick: oe, disabled: O, children: "Try again" }), children: "The login browser was closed prematurely or an error occurred." }) })
  ] });
};
export {
  De as AuthContextProvider,
  Re as useAuth
};
//# sourceMappingURL=index.js.map
